import React, { Component } from "react";
import axiosInstance from "../../axios-project";
import DataLoggingTable from "../../components/DataLoggingTable/DataLoggingTable";
import "bootstrap/dist/css/bootstrap.min.css";



class DataLoggingOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: []
     
    };
  }


  fetchLogging = () => {
    axiosInstance
      .get("/data_logging")
      .then(response => {
        console.log(response.data);
        this.setState(prevState => {
          return {
            users: response.data
          };
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

 


 

  componentDidMount() {
    this.fetchLogging();
  }

  toggleModalHandler = id => {
    this.setState(prevState => {
      return {
        currentUserID: id
      };
    });
  };

  render() {
    const isAdmin = JSON.parse(localStorage.getItem("role")).some(
      r => r.name === "ROLE_ADMIN"
    );
   
    return (
      <div>
     
        <DataLoggingTable
          clicked={this.toggleModalHandler}
          users={isAdmin ? this.state.users : []}
          toggleRoleModal={this.toggleRoleModal}
          togglePasswordModal={this.toggleSignupModal}
          toggleStateModal={this.toggleStateModal}
        />
      
       
       
      </div>
    );
  }
}
export default DataLoggingOverview;
